exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nimg[data-v-7daf6196]\n{\n    max-height:25vh;\n}\n", ""]);

